import DIRECTORIES_SELECTION_STATES from '@wetransfer/transfer/constant/directories-selection-states';
import Browser from '@wetransfer/transfer/modules/concorde-browser';

export function getDirectoriesSelectionState() {
  if (Browser.isMobile) {
    return DIRECTORIES_SELECTION_STATES.NONE;
  }

  // Safari can select files and folders simultaneously
  if (Browser.matches('safari')) {
    return DIRECTORIES_SELECTION_STATES.COMBINED;
  }

  return DIRECTORIES_SELECTION_STATES.SEPARATED;
}
